<template>
  <div class="box animate">
    <div class="swiper" :class="{'animate':animate==true}" ref="swiper" @mouseenter="myPause" @mouseleave="myStart">
      <div class="item" v-for="(item, index) in items" :key="index" @click="jumpToDetail(item)">
        <div class="border"></div>
        <template v-if="current_swiper_type===0">
          <!-- #6ec245绿色 #ddd05e黄色 #ca5857红色 -->
          <div :style="item.type===0?{color:'#ca5857'}:(item.type===1?{color:'#ddd05e'}:{color:'#6ec245'})">
            <p v-for="(x, i) in labels" :key="i">
              <span>{{x.label + '：' + (x.prefixNum?item[x.str].substr(0,x.prefixNum):item[x.str])}}</span>
              <span v-for="(x2,i2) in x.starNum" :key="i2">*</span>
            </p>
          </div>
        </template>
        <template v-else>
          <!-- #6ec245绿色 #ddd05e黄色 #ca5857红色 -->
          <div :style="current_swiper_type===1?{color:'#6ec245'}:(current_swiper_type===2?{color:'#ddd05e'}:{color:'#ca5857'})">
            <!-- <p v-for="(x, i) in labels" :key="i">{{x.label + '：' + item[x.str]}}</p> -->
            <p v-for="(x, i) in labels" :key="i">
              <span>{{x.label + '：' + (x.prefixNum?item[x.str].substr(0,x.prefixNum):item[x.str])}}</span>
              <span v-for="(x2,i2) in x.starNum" :key="i2">*</span>
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isStart: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => [
        {label:'对象姓名',str:'name',prefixNum:1},
        {label:'联系电话',str:'phone',prefixNum:7},
        {label:'身份证号',str:'idCard',prefixNum:10},
      ]
    },
    tab_active_name: {
      type: String,
      default: 'jzfp'
    },
    current_swiper_type: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      animate:false,
    }
  },
  computed: {
    items() {
      return this.list
    },
  },
  methods: {
    scroll() {
      let swiper = this.$refs.swiper
      swiper.style.marginTop = '-' + (this.labels.length * 24 + 16) + 'px'
      console.log(swiper.style.marginTop)
      this.animate = !this.animate
      var timer2 = setTimeout(() => {
        this.items.push(this.items[0])
        this.items.shift()
        swiper.style.marginTop = '0px'
        this.animate = !this.animate // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
        clearTimeout(timer2)
      }, 1000)
    },
    myStart() {
      this.isStart ? this.timer1 = setInterval(this.scroll, 2000) :''
    },
    myPause() {
      clearInterval(this.timer1)
    },
    // 跳转详情
    jumpToDetail(item) {
      let name = ''
      switch (this.tab_active_name) {
        case 'gwzp': name = 'form_gwxxgxqkb'; ;break;
        default: name = 'Form_grxxcj'; break;
      }
      this.myPause()
      this.$router.push({ name, params: { info:[item] } })
    },
  },
  watch: {
    isStart() {
      // console.log(this.list)
      if (this.isStart) {
        this.myStart()
      }
    }
  },
  mounted() {
    // this.start = true
    // this.myStart()
  },

  // 重要！父级必须添加离开守卫！配合ref
  // beforeRouteLeave(to, from, next) {
    // next(this.$refs.myswiper.myPause())
  //   next(this.myPause())
  // }
}
</script>

<style lang="scss" scoped>
.animate {transition: all 1s;}
.box {width: 100%; height: 100%; overflow: hidden;}
.swiper {width: 100%;height: 100%;}
.item {position: relative;padding: 8px;}
// .item:nth-child(2n) {background: #ccc;}
// .item:nth-child(2n+1) {background: #888;}
.item p span{display: inline-block;height: 24px;line-height: 24px;}
.border {
  width: 100%; height: 1px;position: absolute;top: 0; left: 0;
  background: radial-gradient(rgba(13, 254, 255, 0.67) 24%, rgba(51, 51, 51, 0.97) 100%);
}
</style>